import React from "react";
import LpHeader from "./LpHeader/LpHeader";
import LpNavBar from "./LpNavBar/LpNavBar";
import LpServices from "./LpServices/LpServices";
import GoodwayScroll from "./LpAbout/LpAbout";
import LpDocTypes from "./LpDocTypes/LpDocTypes";
import LpEmbassy from "./LpEmbassy/LpEmbassy";
import CountriesCarousel from "../HomePage/CountriesCarousel/CountriesCarousel";
import LpPartners from "./LpPartners/LpPartners";
import LpExp from "./LpExp/LpExp";
import LpFooter from "./LpFooter/LpFooter";
import LpReviews from "./LpReviews/LpReviews";
import Map from "../Map/Map";

const LandingPage = () => {
  return (
    <div className="lpPage-container">
      <LpNavBar />
      <LpHeader />
      <GoodwayScroll />
      <LpEmbassy />
      <LpServices />
      <LpDocTypes />
      <LpExp />
      <CountriesCarousel />
      <LpPartners />
      <LpReviews />
      <Map />
      <LpFooter />
    </div>
  );
};

export default LandingPage;
